import { useDialog } from "../libs/dialog/DialogProvider";
import { Price } from "../models/Price";
import Holding from "../models/Holding";
import GICHistory from "./History/GICHistory";
import CashHistory from "./History/CashHistory";
import EquityHistory from "./History/EquityHistory";
import { ActionFilterProvider } from "../portlibs/ActionFilterProvider";
import { DateRangeFilterProvider } from "../portlibs/DateRangeFilterProvider";

export interface IHistoryProps {
    ticker:string;
}

export function OpenHistory(){
    const {openDialog} = useDialog()

    return (holding:Holding) => {
        const children = Price.isCash(holding.id) ? <CashHistory ticker={holding.id}/> : Price.isGIC(holding.id) || Price.isBond(holding.id) ? <GICHistory ticker={holding.id}/> : <EquityHistory ticker={holding.id}/>
        openDialog({id:"history", children:<ActionFilterProvider><DateRangeFilterProvider>{children}</DateRangeFilterProvider></ActionFilterProvider>})
    }
}
